"use client";

import { c as _c } from "react/compiler-runtime";
import useLocalStorage from "@/hooks/use-local-storage";
import { ingredients } from "@/features/tools/ingredients";
import { Button } from "@/components/ui/button";
import { CopyCheckIcon } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { ChatGPT } from "@/components/ui/icons";
import { ToolData } from ".";
function RecipeGenerator(t0) {
  const $ = _c(27);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedIngredients, setSelectedIngredients] = useLocalStorage("input", t1);
  const query = "Create a delicious recipe using a selection of the following ingredients: " + selectedIngredients.join(", ");
  let t2;
  if ($[1] !== selectedIngredients || $[2] !== setSelectedIngredients) {
    t2 = title_0 => {
      const ingredientItems = ingredients.find(i => i.title === title_0)?.items.map(_temp) ?? [];
      if (ingredientItems.every(i_3 => selectedIngredients.includes(i_3))) {
        setSelectedIngredients(selectedIngredients.filter(ingredient => !ingredients.find(i_1 => i_1.title === title_0)?.items.map(_temp2).includes(ingredient)));
      } else {
        setSelectedIngredients([...selectedIngredients, ...ingredientItems]);
      }
    };
    $[1] = selectedIngredients;
    $[2] = setSelectedIngredients;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onSelectAll = t2;
  let t3;
  if ($[4] !== selectedIngredients || $[5] !== setSelectedIngredients) {
    t3 = (checked, value) => {
      if (checked) {
        setSelectedIngredients([...selectedIngredients, value]);
      } else {
        setSelectedIngredients(selectedIngredients.filter(ingredient_0 => ingredient_0 !== value));
      }
    };
    $[4] = selectedIngredients;
    $[5] = setSelectedIngredients;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onChange = t3;
  let t4;
  if ($[7] !== title) {
    t4 = <CardTitle>{title}</CardTitle>;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = <CardDescription>{description}</CardDescription>;
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <CardHeader>{t4}{t5}</CardHeader>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== onChange || $[15] !== onSelectAll || $[16] !== selectedIngredients) {
    t7 = ingredients.map(t8 => {
      const {
        title: title_1,
        items
      } = t8;
      return <section key={title_1} className="flex flex-col gap-4 p-2"><div className="flex flex-row items-center justify-between"><h3 className="text-muted-foreground font-semibold">{title_1}</h3><Button variant="outline" onClick={() => onSelectAll(title_1)}><CopyCheckIcon /></Button></div><div className="grid grid-cols-2 gap-2">{items.map(t9 => {
            const {
              id,
              name
            } = t9;
            return <div key={id} className="flex items-center gap-2"><Checkbox id={id} name={name} value={name} checked={selectedIngredients.includes(name)} onCheckedChange={checked_0 => onChange(checked_0, name)} /><Label htmlFor={id}>{name}</Label></div>;
          })}</div></section>;
    });
    $[14] = onChange;
    $[15] = onSelectAll;
    $[16] = selectedIngredients;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = selectedIngredients.length === 0 ? undefined : `https://chatgpt.com?q=${query}`;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChatGPT />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8) {
    t10 = <Button disabled={true} className="mt-2" render={<a href={t8} target="_blank">Generate{t9}</a>} />;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t7) {
    t11 = <CardContent className="flex w-full flex-col gap-4">{t7}{t10}</CardContent>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t6) {
    t12 = <Card className="mx-auto w-full">{t6}{t11}</Card>;
    $[24] = t11;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function _temp2(i_2) {
  return i_2.name;
}
function _temp(i_0) {
  return i_0.name;
}
export { RecipeGenerator };